webpackJsonp([263791100135453],{

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _headshot = __webpack_require__(52);
	
	var _headshot2 = _interopRequireDefault(_headshot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About() {
	  return _react2.default.createElement(
	    "div",
	    { className: "narrow-container" },
	    _react2.default.createElement(
	      "p",
	      { className: "center-text" },
	      _react2.default.createElement("img", { className: "headshot", src: _headshot2.default, alt: "Headshot" })
	    ),
	    _react2.default.createElement(
	      "p",
	      { className: "about-p" },
	      "I am a software developer with the majority of my experience in Salesforce development and JavaScript. I work for Concert Health, developing solutions primarily on the Salesforce platform."
	    ),
	    _react2.default.createElement(
	      "p",
	      { className: "about-p" },
	      "Day to day I work primarily with Apex, Lightning Web Components and React. For side projects I enjoy working in TypeScript using React and React Native."
	    ),
	    _react2.default.createElement(
	      "h2",
	      null,
	      "Skills"
	    ),
	    _react2.default.createElement(
	      "ul",
	      { className: "skill-list" },
	      _react2.default.createElement(
	        "li",
	        null,
	        "JavaScript"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "Lightning Web Components"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "Apex"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "TypeScript"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "React"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "Salesforce Lightning"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "Node"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "Express"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "React Native"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "Redis"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "HTML"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "CSS"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "PostgreSQL"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "Git"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "API Development"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "Heroku"
	      )
	    ),
	    _react2.default.createElement(
	      "h2",
	      null,
	      "Education"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Flatiron School - August 2017"
	    ),
	    _react2.default.createElement(
	      "ul",
	      null,
	      _react2.default.createElement(
	        "li",
	        null,
	        "Full Stack Web Development, Ruby on Rails and JavaScript online program"
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Florida Atlantic University - Boca Raton, FL - May 2011"
	    ),
	    _react2.default.createElement(
	      "ul",
	      null,
	      _react2.default.createElement(
	        "li",
	        null,
	        "Master of Accounting and Bachelor of Business Administration with Scholars Distinction"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "Graduated Summa Cum Laude"
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "University of Florida - Gainesville, FL - May 2008"
	    ),
	    _react2.default.createElement(
	      "ul",
	      null,
	      _react2.default.createElement(
	        "li",
	        null,
	        "Bachelor of Arts in History"
	      )
	    )
	  );
	};
	
	exports.default = About;
	module.exports = exports["default"];

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/headshot2.0a069cea.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-8f85ec60f77ce21513b7.js